import { createStore } from 'vuex'
import common from './modules/common'

export default createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: { common }
})